import React from "react";

const AbstractNailArt = () => {
  return (
    <div className="blogWhat-content">
      <h5>7. Abstract & Minimalist Nail Art</h5>
      <p>
        For those who appreciate modern simplicity, abstract nail art is the
        perfect way to express creativity. This trend includes asymmetrical
        designs, negative space, line art, and delicate strokes, creating a
        subtle yet stylish look. Matte finishes, muted tones, and neutral
        palettes work beautifully for a minimalist aesthetic, making this trend
        ideal for office wear or everyday chic.
      </p>
    </div>
  );
};

export default AbstractNailArt;
